import Link from 'next/link';
import { useEffect, useRef, useState, useCallback } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import MetaSeo from '../MetaSeo';
import useTrans from '../../hooks/useTrans';
import { useInView } from 'react-intersection-observer';

export default function Solution(props) {
  const [rows, setRows] = useState([...props.rows] || []);
  const [off_fixed, setOffFixed] = useState('off-fixed');
  const [array_ref, setArrayRef] = useState([]);
  const [boxSidebar, setBoxSidebar] = useState(false);
  const trans = useTrans();
  const [offBox, setOffBox] = useState(true);
  const [listActive, setListActive] = useState(
    rows.map((i, index) => (index === 0 ? true : false)),
  );

  const changeIndex = index => {
    const newList = [...listActive].map((item, i) => {
      if (i === index) {
        return true;
      }
      return false;
    });

    setListActive(newList);
  };
  rows.map((item, index) => {
    const ref = useRef();
    const [inViewRef, inView] = useInView({
      // onChange: (inView) => {
      //   if (inView) {
      //     changeIndex(index);
      //   }
      // },
      threshold: 0,
    });
    const setRefs = useCallback(
      node => {
        // Ref's from useRef needs to have the node assigned to `current`
        ref.current = node;
        // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
        inViewRef(node);
      },
      [inViewRef],
    );
    item.index = index;
    item.ref = {
      ref: setRefs,
      inView: inView,
      refNode: ref,
    };
    return item;
  });
  let lastScrollTop = 0;
  useEffect(() => {
    // setRows(props.rows);
    window.addEventListener('scroll', onScroll);
  }, [props]);

  const onScroll = e => {
    let a = document.getElementById('footer');
    let d = document.getElementById('r-featured-solution-abc');
    let b = a.offsetTop;
    let f = d?.offsetTop;
    let c = e.target.documentElement.scrollTop;

    if (c > b - 800 || c < f + 350) {
      setOffFixed('off-fixed');
    } else {
      setOffFixed('');
    }

    const listActiveRow = rows.filter(item => item.ref.inView);

    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (listActiveRow.length > 0) {
      if (st > lastScrollTop) {
        changeIndex(listActiveRow[listActiveRow.length - 1].index);
      } else {
        changeIndex(listActiveRow[0].index);
      }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  };

  const onClickActive = async (id, index) => {
    const element = document.getElementById(id);
    if (element) {
      const rect = element.getBoundingClientRect();
      const scrollTop = document.documentElement.scrollTop;
      const absoluteY = scrollTop + rect.top;
      document.documentElement.scrollTo({
        top: absoluteY - 200,
        behavior: 'smooth',
      }) ||
        document.documentElement.scrollTo({
          top: absoluteY - 200,
          behavior: 'smooth',
        });
      const newList = listActive.map((item, i) => {
        if (i === index) {
          return true;
        }
        return false;
      });

      setListActive(newList);
    }
  };
  useEffect(() => {
    boxSidebar ? setOffBox(false) : setOffBox(true);
  }, [boxSidebar]);

  const dataSeo = {
    title: 'Solution| TCOM Global',
    description:
      'TCOM Global has been developing many comprehensive technology platforms and solutions, promoting the digital transformation process of businesses and organizations',
  };

  return (
    <>
      {!offBox ? (
        <div
          style={{ cursor: 'pointer' }}
          className="box-off"
          onClick={() => setBoxSidebar(!boxSidebar)}
        ></div>
      ) : null}
      <MetaSeo {...dataSeo} />
      <div className="main-content main-content-solution">
        <div className={`sidebar ${off_fixed}`}>
          <div
            class="js-open-sidebar"
            onClick={() => setBoxSidebar(!boxSidebar)}
          >
            <svg
              width="41"
              height="31"
              viewBox="0 0 41 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_648_1108)">
                <path
                  d="M40.2501 4.71724C40.1562 5.00951 40.0831 5.31223 39.9683 5.6045C39.3733 7.05544 38.058 7.89052 36.3461 7.89052C33.1729 7.89052 29.9892 7.89052 26.8159 7.89052C22.6092 7.89052 18.4025 7.89052 14.1958 7.89052C12.4735 7.89052 11.1374 7.03457 10.5528 5.57319C9.61337 3.21411 11.2418 0.698449 13.8201 0.531435C13.9871 0.520996 14.1541 0.520996 14.3315 0.520996C21.628 0.520996 28.914 0.520996 36.2105 0.520996C38.3921 0.520996 39.6864 1.53352 40.2084 3.65252C40.2188 3.6734 40.2397 3.69427 40.2501 3.71515C40.2501 4.03874 40.2501 4.37277 40.2501 4.71724Z"
                  fill="#0063AA"
                />
                <path
                  d="M40.2501 27.2955C40.1458 27.6191 40.0831 27.9531 39.937 28.2558C39.2585 29.7277 38.0789 30.4583 36.4714 30.4897C35.1562 30.5105 33.841 30.4897 32.5257 30.4897C26.4088 30.4897 20.2814 30.4897 14.1645 30.4897C12.2334 30.4897 10.7512 29.3414 10.365 27.546C9.90566 25.4375 11.461 23.3289 13.6113 23.1514C13.8201 23.1306 14.0288 23.1201 14.2376 23.1201C21.5967 23.1201 28.9558 23.1201 36.3044 23.1201C38.1416 23.1201 39.509 24.0387 40.0518 25.6253C40.1249 25.8446 40.1875 26.0638 40.2501 26.2934C40.2501 26.617 40.2501 26.9615 40.2501 27.2955Z"
                  fill="#0063AA"
                />
                <path
                  d="M40.2504 15.9697C40.1878 16.2098 40.1252 16.4499 40.0521 16.6795C39.5302 18.2244 38.1523 19.1847 36.43 19.1847C29.9582 19.1847 23.4863 19.1847 17.0145 19.1847C15.9602 19.1847 14.906 19.2161 13.8517 19.1743C12.3381 19.1117 11.2212 18.3601 10.6158 16.9822C10.0103 15.6044 10.2191 14.2787 11.1899 13.1096C11.9623 12.2015 12.9748 11.8257 14.1648 11.8257C21.5552 11.8361 28.9561 11.8257 36.3465 11.8257C36.3569 11.8257 36.3673 11.8257 36.3882 11.8257C38.3715 11.8361 39.7285 12.9217 40.1878 14.8528C40.1982 14.9154 40.2296 14.9676 40.2504 15.0303C40.2504 15.3434 40.2504 15.6566 40.2504 15.9697Z"
                  fill="#0063AA"
                />
                <path
                  d="M7.60908 15.4793C7.61952 17.5148 5.99113 19.1641 3.95564 19.1745C1.90971 19.1849 0.25 17.5357 0.25 15.4897C0.25 13.4647 1.89927 11.8154 3.92432 11.8154C5.95981 11.8259 7.59864 13.4543 7.60908 15.4793Z"
                  fill="#0063AA"
                />
                <path
                  d="M7.60908 26.7945C7.60908 28.8195 5.98069 30.4688 3.95564 30.4897C1.93058 30.5001 0.25 28.8195 0.25 26.784C0.25 24.7694 1.92015 23.1097 3.93476 23.1202C5.97025 23.1202 7.59864 24.759 7.60908 26.7945Z"
                  fill="#0063AA"
                />
                <path
                  d="M7.60913 4.20575C7.60913 6.24124 5.98074 7.86963 3.94525 7.88007C1.90976 7.89051 0.23961 6.22036 0.250049 4.17443C0.260487 2.15982 1.93063 0.500109 3.94525 0.510547C5.9703 0.520985 7.60913 2.17026 7.60913 4.20575Z"
                  fill="#0063AA"
                />
              </g>
              <defs>
                <clipPath id="clip0_648_1108">
                  <rect
                    width="40"
                    height="29.9791"
                    fill="white"
                    transform="translate(0.25 0.510498)"
                  />
                </clipPath>
              </defs>
            </svg>
            {/* {trans.layout.service} */}
          </div>
          <div className={boxSidebar ? 'box open' : 'box'}>
            <h3 className="title">
              {trans?.solution?.our_service_sub1}
              <br /> {trans?.solution?.our_service_sub2}
            </h3>
            <ul>
              {rows.map((item, index) => {
                return (
                  <li className={listActive[index] ? 'active' : ''}>
                    {/* <a href={`/${router.locale}/service/${item.seo_url}`}>{item.title}</a> */}
                    <a
                      onClick={() => {
                        onClickActive(item.group_id, index);
                        setBoxSidebar(!boxSidebar);
                      }}
                    >
                      {item.title}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="r-featured-solution" id="r-featured-solution-abc">
          <div className="r-featured-solution-content">
            <h1>{trans.solution.title_solution}</h1>
            <p>{trans.solution.title_solution_des}</p>
          </div>
        </div>
        <div className="r-solution-list">
          <div className="container" style={{ maxWidth: '1110px', padding: 0 }}>
            <ul>
              {rows?.map((data, index) => {
                return (
                  <li
                    id={data.group_id}
                    key={index}
                    style={{ background: `url(${data.image})` }}
                  >
                    <div className="box">
                      <div className="title-box-solution">
                        <p>{data.title}</p>
                      </div>
                      <p
                        className="name"
                        dangerouslySetInnerHTML={{
                          __html: data.description_short,
                        }}
                      ></p>
                      <p ref={data?.ref?.ref}></p>
                      {/* <a
                        href={data.url}
                        className="readmore"
                        style={{ textDecoration: 'none' }}
                        target="_blank"
                        ref={data?.ref?.ref}
                      >
                        {trans.text_button.read_more_b}
                        <svg
                          width={32}
                          height={32}
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx={16} cy={16} r={16} fill="#0063AA" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5 16.2491C5 16.0501 5.07902 15.8594 5.21967 15.7187C5.36032 15.5781 5.55109 15.4991 5.75 15.4991L23.4395 15.4991L18.719 10.7801C18.5782 10.6392 18.4991 10.4482 18.4991 10.2491C18.4991 10.0499 18.5782 9.85888 18.719 9.71805C18.8598 9.57722 19.0508 9.49811 19.25 9.49811C19.4492 9.49811 19.6402 9.57722 19.781 9.71805L25.781 15.7181C25.8508 15.7877 25.9063 15.8705 25.9441 15.9616C25.9819 16.0527 26.0013 16.1504 26.0013 16.2491C26.0013 16.3477 25.9819 16.4454 25.9441 16.5365C25.9063 16.6276 25.8508 16.7104 25.781 16.7801L19.781 22.7801C19.6402 22.9209 19.4492 23 19.25 23C19.0508 23 18.8598 22.9209 18.719 22.7801C18.5782 22.6392 18.4991 22.4482 18.4991 22.2491C18.4991 22.0499 18.5782 21.8589 18.719 21.7181L23.4395 16.9991L5.75 16.9991C5.55109 16.9991 5.36032 16.92 5.21967 16.7794C5.07902 16.6387 5 16.448 5 16.2491Z"
                            fill="white"
                          />
                        </svg>
                      </a> */}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
